import { create } from 'zustand';

const UUID_STORAGE_KEY = 'elva_selected_location_uuid';
const CORE_STORAGE_KEY = 'elva_selected_core_location_id';

interface LocationState {
  selectedLocationUuid: string | null;
  selectedCoreLocationId: number | null;
  setSelectedLocationUuid: (locationUuid: string | null) => void;
  setSelectedCoreLocationId: (locationId: number | null) => void;
  resetLocationSelection: () => void;
  /** @deprecated Use `setSelectedLocationUuid`. */
  setSelectedLocationId: (locationId: string | null) => void;
  getSelectedLocationUuid: () => string | null;
  getSelectedCoreLocationId: () => number | null;
  /** @deprecated Use `getSelectedLocationUuid`. */
  getSelectedLocationId: () => string | null;
}

export const useLocationStore = create<LocationState>((set, get) => ({
  selectedLocationUuid: null,
  selectedCoreLocationId: null,

  setSelectedLocationUuid: (locationUuid) => {
    set({ selectedLocationUuid: locationUuid });

    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      if (locationUuid !== null) {
        localStorage.setItem(UUID_STORAGE_KEY, locationUuid);
      } else {
        localStorage.removeItem(UUID_STORAGE_KEY);
      }
    }
  },

  setSelectedCoreLocationId: (locationId) => {
    set({ selectedCoreLocationId: locationId });

    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      if (locationId !== null) {
        localStorage.setItem(CORE_STORAGE_KEY, locationId.toString());
      } else {
        localStorage.removeItem(CORE_STORAGE_KEY);
      }
    }
  },

  resetLocationSelection: () => {
    get().setSelectedLocationUuid(null);
    get().setSelectedCoreLocationId(null);
  },

  setSelectedLocationId: (locationId) => {
    get().setSelectedLocationUuid(locationId);
  },

  getSelectedLocationUuid: () => get().selectedLocationUuid,
  getSelectedCoreLocationId: () => get().selectedCoreLocationId,
  getSelectedLocationId: () => get().selectedLocationUuid,
}));

function initializeFromStorage(): void {
  try {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
      return;
    }

    const storedUuid = localStorage.getItem(UUID_STORAGE_KEY);
    if (storedUuid) {
      useLocationStore.getState().setSelectedLocationUuid(storedUuid);
    }

    const legacyNumeric = localStorage.getItem('selectedLocationId');
    if (legacyNumeric) {
      localStorage.removeItem('selectedLocationId');
    }
  } catch (error) {
    console.warn('Failed to initialize location from localStorage:', error);
  }
}

if (typeof window !== 'undefined') {
  initializeFromStorage();
}
